import React from 'react';
import { withRouter } from 'react-router-dom';

class RemoverMovimentacao extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centro: "",
            centroId: 0,
            id: "",
            filtroAno: "",
            filtroMes: "",
            vecMovPrev: null,
            vecMov: null
        };

        this.confirmar = this.confirmar.bind(this);
        this.cancelar = this.cancelar.bind(this);

    }

    confirmar() {

        this.setState({ disabled: true });
        this.props.waitMsgHandler("Aguardando");

        let obj = {
            "_id": this.state.id
        };

        fetch("/api/movimentacao/", {
            method: "DELETE",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors",
            body: JSON.stringify(obj)
        })
        .then(response => response.json())
        .then(responseJson => {

            if (responseJson.msg === "success") {

                this.props.waitMsgHandler("");
                this.props.successMsgHandler("Movimentação financeira removida com sucesso.");

                let obj2 = {
                    row: {
                        id: this.state.centroId,
                        data: [ this.state.centro ],
                        filtroAno: this.state.filtroAno,
                        filtroMes: this.state.filtroMes
                    }
                };

                this.props.history.push({
                    pathname: "/movimentacoescentro",
                    state: obj2
                });

            }

        });

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: []
            },
            filtroAno: this.state.filtroAno,
            filtroMes: this.state.filtroMes,
            vecMovPrev: this.state.vecMovPrev,
            vecMov: this.state.vecMov
        };

        this.props.history.push({
            pathname: "/visualizarmovimentacao",
            state: obj
        });

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes !== "escrever"
            && localStorage.roleMovimentacoes !== "corrigir") {

            window.location.href = "/home";

        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoes";
        }

        let centro = this.props.location.state.centro;
        let centroId = this.props.location.state.centroId;
        let id = this.props.location.state.id;
        let filtroAno = this.props.location.state.filtroAno;
        let filtroMes = this.props.location.state.filtroMes;
        let vecMovPrev = this.props.location.state.vecMovPrev;
        let vecMov = this.props.location.state.vecMov;

        this.setState({ centro: centro });
        this.setState({ centroId: centroId });
        this.setState({ id: id });
        this.setState({ filtroAno: filtroAno });
        this.setState({ filtroMes: filtroMes });
        this.setState({ vecMovPrev: vecMovPrev });
        this.setState({ vecMov: vecMov });

    }

    render() {
        return(
            <div>
                <h1 id="remover-movimentacao-title">
                    Remover Movimentação Financeira
                </h1><br />
                <p id="remover-movimentacao-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br /><br />
                <p id="remover-movimentacao-txt">
                    Deseja realmente efetuar a remoção desta movimentação financeira?
                </p><br /><br />
                <button Class="remover-movimentacao-btn"
                    id="remover-movimentacao-confirmar-btn"
                    onClick={ this.confirmar }
                    disabled={ this.state.disabled }>Confirmar</button>
                <button Class="remover-movimentacao-btn"
                    id="remover-movimentacao-cancelar-btn"
                    onClick={ this.cancelar }>Cancelar</button>
                <br /><br />
            </div>
        );
    }

}

export default withRouter(RemoverMovimentacao);

